import type { ApolloError } from '@apollo/client';

export type GraphQLErrorLike = {
    message?: string;
    extensions?: Record<string, unknown>;
};

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

function isGraphQLErrorLike(
    value: GraphQLErrorLike | undefined,
): value is GraphQLErrorLike {
    return value !== undefined;
}

function toGraphQLErrorLike(value: unknown): GraphQLErrorLike | undefined {
    if (!isRecord(value)) {
        return undefined;
    }

    return {
        message: typeof value.message === 'string' ? value.message : undefined,
        extensions: isRecord(value.extensions) ? value.extensions : undefined,
    };
}

export function getGraphQLErrorsFromApolloError(
    error: ApolloError,
): GraphQLErrorLike[] {
    const networkResult =
        isRecord(error.networkError) && 'result' in error.networkError
            ? error.networkError.result
            : undefined;

    if (isRecord(networkResult) && Array.isArray(networkResult.errors)) {
        return networkResult.errors
            .map(toGraphQLErrorLike)
            .filter(isGraphQLErrorLike);
    }

    return error.graphQLErrors
        .map(toGraphQLErrorLike)
        .filter(isGraphQLErrorLike);
}

export function getErrorMessageFromApolloError(error: ApolloError): string {
    return getGraphQLErrorsFromApolloError(error)[0]?.message ?? error.message;
}
